<template>
  <div class="odmik-naroci-televizija">
    <div>
      <div>
        <ul>
          <li>
            <img src="/static/img/Naroci/NarociTelevizija/Icon-awesome-tv.png">
            <span class="open-sans-20pt">
              {{coaxPrikljucek ? 'TV vmesniki in druga oprema' : 'TV vmesniki'}}
            </span>
          </li>
        </ul>
      </div>
      <div style="padding-top: 20px" :v-loading="nalaganjeStoritve">
        <div>
          <p class="navadno-besedilo" v-if="coaxPrikljucek">
            TV vmesnik in DVB-C sprejemnik sta napravi, ki uporabniku omogočata spremembo digitalnega signala
            v ustrezno obliko, s tem pa sprejem slike in zvoka na obstoječem TV sprejemniku. <br/>
            Kodirna TV kartica omogoča dostop (ogled) naročenih digitalnih TV programov.
          </p>
          <p v-else>
            Set-top box (STB) ali TV vmesnik je naprava, ki uporabniku omogoča spremembo digitalnega signala
            v ustrezno obliko, s tem pa sprejem slike in zvoka na obstoječem TV sprejemniku. <br/>
            Izbirate lahko med HD ali 4K vmesnikom, odvisno od tipa vašega TV sprejemnika.
            V izbirnikih je označeno skupno število naročenih in vklopljenih TV vmesnikov. <br/>
            Za spremembo nabora storitev, izberite število TV vmesnikov in oddajte naročilo.
            Za naročilo aplikacije T-2 TV izberite meni
            <a href="/Naroci/TVsmart" class="primarna-barva">
              Smart TV
            </a>.
          </p>
        </div>
        <div v-if="Object.keys(asocSeznamVklopljenih).length > 0"
             class="zgornji-odmik-sprememba-telefonije forma-izbira-st-prikljuckov">
          <div v-for="storitev in seznamTvVmesnikov">
            <el-form label-width="210px" :label-position="formaOrientacija">
              <el-form-item :label=storitev.opis>
                <el-select v-model="izbranaKolicina[storitev.id]"
                           placeholder="Izberi"
                           :disabled="typeof asocSeznamNarocenih[storitev.id] !== 'undefined'"
                           :class="'velikost-izbirnika-kolicin '  +
                           (asocSeznamVklopljenih[storitev.id].kolicina !== izbranaKolicina[storitev.id] ? 'temna-pisava' :'')">
                  <el-option
                    v-for="data in moznaIzbira"
                    :key="data"
                    :label="data"
                    :value="data">
                  </el-option>
                </el-select>
                <span v-if="typeof asocSeznamNarocenih[storitev.id] !== 'undefined'" style="padding-left: 15px;">
                  <b>
                    Naročilo v teku...
                  </b>
                </span>
              </el-form-item>
            </el-form>
          </div>
          <OrderButton
            :services="GetServices"
            class="postavitev-gumb-narocanje"
            :disabled="allServicesSameTypeInOrder"
            :style="prikazTabele === '1' ? 'width: 250px;' : ''"
            :service-name="quantityIsAllLower ? 'izbrane tv vmesnike' : 'spremembo tv vmesnikov'"
            :use-primary-class-only="true"
            @orderConfirmed="$emit('osvezitevStraniDodajanje'); OsveziPodatke()"
            :lower-quantity="quantityIsAllLower"
          >
            ODDAJTE SPREMEMBE
          </OrderButton>
        </div>
<!--        <div v-if="Object.keys(asocSeznamVklopljenih).length > 0" class="razlaga-st-vmesnikov">
          <div class="postavitev-info">
            <div class="info-okvir">
              <div class="postavitev-info-icone">
                <i class="fa fa-info-circle"></i>
              </div>
              <div class="postavitev-info-tekst">
                <p class="modra-barva-info">
                  V izbirnikih je označeno skupno število naročenih in vklopljenih TV vmesnikov. Za spremembo nabora
                  storitev, izberite število TV vmesnikov in oddajte naročilo. Za naročilo aplikacije T-2 TV izberite
                  meni
                  <a href="/Naroci/TVsmart" class="modra-barva-info">
                    <b>Smart TV</b>
                  </a>.
                  <div class="modra-barva-info" style="padding-top: 25px">
                    <b>
                      Vse spremembe storitev televizije je možno opraviti enkrat na mesec.
                    </b>
                    Naročeno spremembo televizije lahko tudi prekličete, če ta še ni bila vključena.
                  </div>
                </p>
              </div>
              <div style="clear: both"/>
            </div>
          </div>
        </div>-->
      </div>
      <div class="postavitev-gumb-narocanje" style="clear: both;">
        <br/>
        <a :href="cenikTelevizije" class="primarna-barva" target="_blank">
          Cenik za televizijo
        </a>
      </div>
      <div>
        <div v-if="seznamNarocenihSpremembIzpis.length > 0" style="padding-top: 30px; padding-bottom: 30px">
          <p class="open-sans-20pt">
            Spremembe naročenih storitev
          </p>
          <div v-show="prikazTabele === '1'">
            <el-table :data="seznamNarocenihSpremembIzpis">
              <el-table-column prop="opis" label="Storitev" />
              <el-table-column prop="trajanjeOd" label="Datum naročila" />
              <el-table-column prop="kolicinaPlus" label="Naročena količina" />
              <el-table-column prop="kolicinaMinus" label="Odjavljena količina" />
              <el-table-column prop=""
                               label="Status naročila">
                <template>
                  V obdelavi
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="prikazTabele === '0'">
            <el-table
              :data="seznamNarocenihSpremembIzpis"
              :expand-row-keys="expandRowKeys"
              :row-key="row => row.idStoritev"
              @expand-change="IzbiraVrsticeZaPregledStoritve">
              <el-table-column prop="opis"
                               label="Storitev">
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div>
                    <p>
                      <span>
                        <b>
                          Storitev:
                        </b>
                      </span>
                      {{ scope.row.opis }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Datum naročila:
                        </b>
                      </span>
                      {{ scope.row.trajanjeOd }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Naročena količina:
                        </b>
                      </span>
                      {{ scope.row.kolicinaPlus }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Odjavljena količina
                        </b>
                      </span>
                      {{ scope.row.kolicinaMinus }}
                    </p>
                    <p>
                      <span>
                        <b>
                          Status naročila:
                        </b>
                      </span>
                      V obdelavi
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <OrderExistsInfo v-if="Object.keys(asocSeznamNarocenih).length > 0"/>
    </div>
  </div>
</template>
<script>
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {
  Button,
  Collapse,
  CollapseItem,
  Select,
  Option,
  Loading,
  Table,
  TableColumn,
  Tooltip
} from 'element-ui'
import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
import Vue from 'vue'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'
export default {
  mixins: [PrikazVsebine],
  name: 'TVvmesnik',
  data () {
    return {
      moznaIzbira: [],
      seznamNarocenihIzpis: [],
      izbranaKolicina: {},
      zmanjsanaKolicina: {},
      formaOrientacija: 'left',
      cenikTelevizije: '',
      mejnaSirina: 600,
      kontaktniPodatki: null,
      nalaganjeStoritve: false,
      expandRowKeys: [],
      mejnaSirinaTabela: 1000,
      prikazTabele: '1',
      asocSeznamNarocenih: {},
      asocSeznamVklopljenih: {},
      seznamNarocenihSpremembIzpis: []
    }
  },
  props: {
    coaxPrikljucek: false,
    izbranPrikljucek: null,
    seznamNarocenihTvVmesnikov: null,
    seznamVkloplenihTvVmesnikov: null,
    stPosodobitveKolicineTvVmesnikov: 0,
    seznamTvVmesnikov: null,
    cenikTvVmesnikov: null
  },
  components: {
    OrderExistsInfo,
    OrderButton,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Loading.name]: Loading,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  watch: {
    stPosodobitveKolicineTvVmesnikov: function () {
      if (this.stPosodobitveKolicineTvVmesnikov > 0 && this.stPosodobitveKolicineTvVmesnikov % 2 === 0) {
        this.OsveziPodatke()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.cenikTelevizije = povezave.BASE_URL_CENIK_TELEVIZIJA
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.dispatchEvent(new Event('resize'))
    })
    this.MozneIzbireTelevizija()
  },
  computed: {
    GetServices () {
      let services = []
      for (let key in this.izbranaKolicina) {
        if (typeof this.izbranaKolicina[key] !== 'number' && !isFinite(this.izbranaKolicina[key])) {
          continue
        }
        let obstajaNarocenaKolicina = typeof this.asocSeznamNarocenih[key] !== 'undefined'
        if (
          (obstajaNarocenaKolicina && this.asocSeznamNarocenih[key].kolicina !== this.izbranaKolicina[key]) ||
          (!obstajaNarocenaKolicina && this.asocSeznamVklopljenih[key].kolicina !== this.izbranaKolicina[key])) {
          let quantityIsLower = false
          if (
            (obstajaNarocenaKolicina && this.asocSeznamNarocenih[key].kolicina > this.izbranaKolicina[key]) ||
            (!obstajaNarocenaKolicina && this.asocSeznamVklopljenih[key].kolicina > this.izbranaKolicina[key])
          ) {
            quantityIsLower = true
          }
          services.push({
            serviceId: Number.parseInt(key),
            quantity: this.izbranaKolicina[key],
            terminationPointId: Number.parseInt(this.izbranPrikljucek),
            quantityIsLower: quantityIsLower
          })
        }
      }
      return services
    },
    showOrderButton () {
      return this.GetServices.length !== 0
    },
    quantityIsAllLower () {
      let services = this.GetServices
      for (let i = 0; i < services.length; i++) {
        if (!services[i].quantityIsLower) {
          return false
        }
      }
      return true
    },
    allServicesSameTypeInOrder () {
      let out = true
      if (Array.isArray(this.seznamTvVmesnikov)) {
        this.seznamTvVmesnikov.forEach((item) => {
          if (typeof this.asocSeznamNarocenih[item.id] === 'undefined') {
            out = false
          }
        })
      }
      return out
    }
  },
  methods: {
    IzbiraVrsticeZaPregledStoritve (row) {
      const id = row.idStoritev
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    OsveziPodatke () {
      this.seznamNarocenihIzpis = []
      this.SetSeznamNarocenihStoritev()
      this.SetSeznamVkloplenihStoritev()
    },
    MozneIzbireTelevizija () {
      this.moznaIzbira = []
      for (let i = 0; i <= 5; i++) {
        this.moznaIzbira.push(i)
      }
    },
    SetseznamNarocenih (podatki, storitevKolicina) {
      let paramObvestilo = {}
      if (storitevKolicina !== -1) {
        paramObvestilo.message = 'Naročilo uspešno oddano!'
        for (let i = 0; i < this.seznamNarocenihSpremembIzpis.length; i++) {
          if (this.seznamNarocenihSpremembIzpis[i].idStoritev.toString() === storitevKolicina.key) {
            if (storitevKolicina.kolicina !== 0) {
              let paramObvestilo = {}
              paramObvestilo.message += this.seznamNarocenihSpremembIzpis[i].opis + ' (količina: ' +
                storitevKolicina.kolicina + ')'
            }
          }
        }
        this.ShowSuccessMessage(paramObvestilo)
      } else { // preklic
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno preklicano naročilo sprememb storitev.'
        this.ShowSuccessMessage(paramObvestilo)
        this.seznamNarocenihIzpis = []
      }
      this.$emit('osvezitevStraniDodajanje')
      this.OsveziPodatke()
    },
    SetSeznamNarocenihStoritev () {
      this.izbranaKolicina = {}
      this.asocSeznamNarocenih = {}
      for (let i = 0; i < this.seznamNarocenihTvVmesnikov.length; i++) {
        this.seznamNarocenihIzpis.push(this.seznamNarocenihTvVmesnikov[i])
        let idStoritev = this.seznamNarocenihTvVmesnikov[i].idStoritev
        Vue.set(this.izbranaKolicina, idStoritev, this.seznamNarocenihTvVmesnikov[i].kolicina)
        Vue.set(this.asocSeznamNarocenih, idStoritev, JSON.parse(JSON.stringify(this.seznamNarocenihTvVmesnikov[i])))
      }
    },
    SetSeznamVkloplenihStoritev () {
      this.asocSeznamVklopljenih = {}
      if (this.seznamVkloplenihTvVmesnikov !== null) {
        for (let i = 0; i < this.seznamVkloplenihTvVmesnikov.length; i++) {
          let idStoritev = this.seznamVkloplenihTvVmesnikov[i].idStoritev
          if (!(idStoritev in this.izbranaKolicina)) {
            Vue.set(this.izbranaKolicina, idStoritev, this.seznamVkloplenihTvVmesnikov[i].kolicina)
          }
          Vue.set(this.asocSeznamVklopljenih, idStoritev, this.seznamVkloplenihTvVmesnikov[i])
        }
      }
      for (let i = 0; i < this.seznamTvVmesnikov.length; i++) {
        let idStoritev = this.seznamTvVmesnikov[i].id
        if (!(idStoritev in this.izbranaKolicina)) {
          Vue.set(this.izbranaKolicina, idStoritev)
        }
        if (!(idStoritev in this.asocSeznamVklopljenih)) {
          let obj = {}
          obj.kolicina = 0
          Vue.set(this.asocSeznamVklopljenih, idStoritev, obj)
        }
      }
      this.seznamNarocenihSpremembIzpis = []
      let stevec = 0
      for (let i in this.asocSeznamNarocenih) {
        let vklopljenaKolicina = 0
        if (typeof this.asocSeznamVklopljenih[i] !== 'undefined') {
          vklopljenaKolicina = this.asocSeznamVklopljenih[i].kolicina
        }
        let razlikaKolicin = this.asocSeznamNarocenih[i].kolicina - vklopljenaKolicina
        if (razlikaKolicin !== 0) {
          let obj = JSON.parse(JSON.stringify(this.asocSeznamNarocenih[i]))
          obj.kolicina = razlikaKolicin
          if (razlikaKolicin > 0) {
            obj.kolicinaPlus = razlikaKolicin
            obj.kolicinaMinus = 0
          } else if (razlikaKolicin < 0) {
            obj.kolicinaPlus = 0
            obj.kolicinaMinus = razlikaKolicin * -1
          }
          Vue.set(this.seznamNarocenihSpremembIzpis, stevec++, obj)
        }
      }
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/TVvmesnik.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/TVvmesnik.vue